var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('param-box',{staticClass:"border border-gray-400 dark:border-gray-900 bg-gray-300 dark:bg-gray-700",attrs:{"title":_vm.title,"icon":_vm.icon}},[_vm._t("title",null,{"slot":_vm.title}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }